/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Router, { Location, RawLocation } from 'vue-router';
import routes from '@/router/routes';
import microMenus from '@/router/microMenus';
import override from '@/router/override';
import store from '@/store';
import { overrideRoute } from 'common-module/src/util/routerUtil';
import NProgress from 'nprogress';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/kanban/list',
      meta: {
        hidden: true
      }
    },
    ...overrideRoute(routes, override).map((r: any) => ({ ...r, path: `/${r.path}` })),
    ...microMenus
  ]
});

type MetaLocation = Location & {
  meta?: any
}
type BeforeLocation = (to: MetaLocation) => Location | void;
const beforeCallbacks = new Set<BeforeLocation>();
const addBeforeLocation = (fn: BeforeLocation) => {
  beforeCallbacks.add(fn);
};
const eachBeforeLocation = (to: RawLocation): Location => {
  // 参数归一化
  const { name, path, hash, query, params, meta } = router.resolve(to).resolved;
  let location: MetaLocation = { name: name || undefined, path, hash, query, params, meta };
  beforeCallbacks.forEach(async fn => {
    location = fn(location) || location;
  });
  return location;
};

// 当前有项目ID && url没有pid时，自动更新url
addBeforeLocation((to) => {
  // 不需要项目的路由页面都过滤掉，不对路由的query做处理
  const isRouteIgnored = [
    '/404',
    '/dashboard',
    '/setting',
    '/release',
    '/roadmap',
    '/team',
    '/project/list',
    '/share',
    '/guide',
    '/welcome'
  ].some((prefix: string) => to.path?.startsWith(prefix));
  if (isRouteIgnored) {
    return;
  }
  const pid = store.getters['app/currentProject']?.id;
  if (pid && !to.query?.pid) {
    to.query = { ...(to.query || {}), pid };
  }
});

// 当路由异常时不会执行afterEach钩子，所以在这里完成进度条的结束
const oldTransitionTo = (router as any).history.transitionTo;
(router as any).history.transitionTo = function (location: RawLocation, onComplete?: Function, onAbort?: Function) {
  return Reflect.apply(oldTransitionTo, this, [location, onComplete, (err: any) => {
    onAbort && onAbort(err);
    NProgress.done();
  }]);
};
export default new Proxy<Router>(router, {
  get(target, p, r) {
    const value = Reflect.get(target, p, r);
    if (typeof p === 'string' && ['push', 'replace'].includes(p)) {
      return (location: RawLocation, ...args: any[]) => {
        // 执行地址前置钩子
        location = eachBeforeLocation(location);
        const onAbort = args[1];
        args[1] = (err: any) => {
          onAbort && onAbort(err);
          NProgress.done();
        };
        const result = Reflect.apply(value, target, [location, ...args]) as any;
        // 解决两次访问相同路由地址报错, 忽略报错
        if (result?.catch) {
          return result.catch((err: Error) => {
            if (!Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated) &&
              !Router.isNavigationFailure(err, Router.NavigationFailureType.redirected)) {
              throw err;
            }
          });
        }
        return result;
      };
    }
    return value;
  }
});
